import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { Prod01 } from '../../constants/ActionType';

/** Doctors in the patient's organization, labelled "First M. Last, MD". value/onChange = doctor _id. */
const ProviderSelect = ({ organizationId, value, onChange, warning, inputId = 'provider-select' }) => {
    const [options, setOptions] = useState([]);
    const [loadError, setLoadError] = useState(null);
    useEffect(() => {
        let alive = true;
        setLoadError(null);
        if (!organizationId) {
            setOptions([]);
            return undefined;
        }
        axios
            .get(`${Prod01}/patient/form/providers`, { params: { organizationId } })
            .then(({ data }) => alive && setOptions((data || []).map((d) => ({ value: String(d._id), label: d.label }))))
            .catch((e) => alive && setLoadError(e?.response?.data?.message || e.message));
        return () => {
            alive = false;
        };
    }, [organizationId]);
    const selected = options.find((o) => o.value === String(value || '')) || null;
    return (
        <div className="mb-2">
            <label htmlFor={inputId} className="form-label mt-3">Provider</label>
            <Select
                inputId={inputId}
                options={options}
                value={selected}
                isClearable
                isDisabled={!organizationId}
                placeholder={organizationId ? 'Select provider' : 'Select organization first'}
                onChange={(o) => onChange(o ? o.value : '')}
            />
            {loadError ? <div className="error">{loadError}</div> : null}
            {!loadError && warning ? <small className="text-warning" data-testid="provider-warning">{warning}</small> : null}
        </div>
    );
};

export default ProviderSelect;
